import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { StyledButtonText } from '../Button/ButtonText';

export const StyledLinkText = styled(StyledButtonText)<{}>``;

interface ILinkTextProps {
	children: ReactNode;
	className?: string;
	ariaHidden?: boolean;
}

export const LinkText = ({
	children,
	ariaHidden,
	className,
}: ILinkTextProps) => (
	<>
		{typeof children === 'string' ? (
			<StyledLinkText className={className} aria-hidden={ariaHidden}>
				{children}
			</StyledLinkText>
		) : (
			children
		)}
	</>
);
